// extracted by mini-css-extract-plugin
export default {"paragraph":"StepName_paragraph__IutTG"};